import { render } from "./OmmpBody.vue?vue&type=template&id=1310df14&scoped=true"
import script from "./OmmpBody.vue?vue&type=script&lang=js"
export * from "./OmmpBody.vue?vue&type=script&lang=js"

import "./OmmpBody.vue?vue&type=style&index=0&id=1310df14&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1310df14"]])

export default __exports__